module.exports = __webpack_public_path__ + "img/db.83a123d4.svg";